import { useState } from 'react'
import { signInWithGoogle, isAllowed, signOut } from '../firebase'
import { useAuth } from '../auth/AuthContext'

export function Login() {
  const { user, redirectError } = useAuth()
  const [err, setErr] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const onClick = async () => {
    setErr(null)
    setBusy(true)
    try {
      const u = await signInWithGoogle()
      // null ⇒ full-page redirect started; keep busy until unload
      if (!u) return
      if (!isAllowed(u)) {
        await signOut()
        setErr('Den här e-postadressen har inte tillgång till dashboarden.')
      }
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : 'Inloggning avbruten'
      setErr(msg)
    } finally {
      setBusy(false)
    }
  }

  const displayErr = err || redirectError

  return (
    <div className="login">
      <div className="login__card">
        <div className="login__title">Bolag</div>
        <div className="login__sub">
          Dashboard — skattekonto, momsbalans och resultat för dina bolag.
        </div>
        <button className="login__btn" onClick={onClick} disabled={busy}>
          <span style={{ fontSize: '1.1rem' }}>🔐</span>
          {busy ? 'Loggar in…' : 'Logga in med Google'}
        </button>
        {user && !isAllowed(user) && (
          <div className="login__err">
            Inloggad som {user.email} — men bara davidrad@gmail.com har tillgång.
            <br />
            <button
              className="logout-btn"
              style={{ marginTop: '0.5rem' }}
              onClick={() => signOut()}
            >
              Logga ut
            </button>
          </div>
        )}
        {displayErr && <div className="login__err">{displayErr}</div>}
      </div>
    </div>
  )
}
